export default __webpack_public_path__ + "static/media/BUFFALO.9c96cfb5.gif";